// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_RequestInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/anticipations/request
 *
 * Requests anticipation of a payment.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_RequestInput {
subaccount_id: number
payment_id: string
installment_id?: string
payment_link_id?: number
}

registerContract('SubaccountsAnticipations_RequestInput', {
  subaccount_id:   { type: 'number',  required: true },
  payment_id:      { type: 'string',  required: true },
  installment_id:  { type: 'string',  required: false },
  payment_link_id: { type: 'number',  required: false },
})
